import produce from 'immer';
import { ActionType } from '../action-types';
import { Action } from '../actions';
import { initialStates } from '../initial-states/initialStates';
import { LockerState } from '../initial-states/stateTypes';

const initialState = initialStates.locker.normalState;

const reducer = produce((state: LockerState = initialState, action: Action) => {
  switch (action.type) {
    case ActionType.UPDATE_IS_AGENT_PROCESS:
      state.isAgentProcess = action.payload;
      return state;
    case ActionType.UPDATE_CURRENT_LOCKER_POSITION:
      state.currentLockerPosition = action.payload;
      return state;
    case ActionType.UPDATE_CURRENT_PACKAGE_CANDIDATE:
      state.currentPackageCandidate = action.payload;
      return state;
    case ActionType.UPDATE_REMOVE_LOCKER_LIST:
      state.lockerRemoveList = action.payload;
      return state;
    case ActionType.UPDATE_EMPLOYEE_NUMBER:
      state.employeeNumber = action.payload;
      return state;
    case ActionType.UPDATE_IS_MULTIDELIVERY:
      state.isMultiDelivery = action.payload;
      return state;
    case ActionType.UPDATE_CUSTOMER_NAME:
      state.customerName = action.payload;
      return state;
    case ActionType.UPDATE_CUSTOMER_SIGNATURE:
      state.customerSignature = action.payload;
      return state;
    case ActionType.UPDATE_LOCKER_CONTENT:
      state.lockerContent = action.payload;
      return state;
    case ActionType.UPDATE_LOCKER_RACK_ID:
      state.lockerRackId = action.payload;
      return state;
    case ActionType.LOCKER_RESET:
      return initialState;
    default:
      return state;
  }
}, initialState);

export default reducer;
